import React from "react";
import { Checkbox } from "@/components/ui/checkbox";
import { ColumnDef } from "@tanstack/react-table";

type SelectColumnOptions = {
  allowAllSelectedExclusions?: boolean;
};

export const createSelectColumn = ({
  allowAllSelectedExclusions = false,
}: SelectColumnOptions = {}): ColumnDef<any, any> => ({
  id: "select",
  header: ({ table }) => (
    <Checkbox
      onClick={(ev) => ev.stopPropagation()}
      checked={
        table.getIsAllPageRowsSelected() ||
        (table.getIsSomePageRowsSelected() && "indeterminate")
      }
      onCheckedChange={(value) => {
        if (!!value === false && table.getAllSelected()) {
          table.setAllSelected(false);
          table.resetRowSelection();
        } else {
          table.toggleAllPageRowsSelected(!!value);
        }
      }}
      aria-label="Select all"
      className="translate-y-[2px]"
    />
  ),
  cell: ({ row, table }) => {
    const isAllSelected = table.getAllSelected();
    const isExcluded = table.getState().rowSelection[row.id] === false;
    return (
      <Checkbox
        onClick={(ev) => ev.stopPropagation()}
        checked={isAllSelected ? !isExcluded : row.getIsSelected()}
        onCheckedChange={(value) => {
          if (isAllSelected && allowAllSelectedExclusions) {
            table.setRowSelection((current) => ({
              ...current,
              [row.id]: !!value,
            }));
          } else {
            row.toggleSelected(!!value);
          }
        }}
        aria-label="Select row"
        className="translate-y-[2px]"
        disabled={isAllSelected && !allowAllSelectedExclusions}
      />
    );
  },
  size: 32,
  minSize: 32,
  maxSize: 32,
  enableResizing: false,
  enableSorting: false,
  enableHiding: false,
  meta: {
    width: "32px",
    box: {
      hidden: true,
    },
  },
});

export const selectColumn = createSelectColumn();
